const formatPhoneNumber = (phone: string): string => {
    return `${phone.slice(0, 3)} (${phone.slice(3, 5)}) ${phone.slice(5, 8)}-${phone.slice(8, 12)}`;
};

export default formatPhoneNumber;
